import axios from 'axios'
//创建axios实例
const service = axios.create({
    //baseURL: "http://127.0.0.1:9090",
    baseURL: "https://admin.dongyuanlawyersz.com/prod-api",
    timeout: 10000,
    headers: {
        "Content-Type": "application/json;charset=utf-8"
    }
})

//请求拦截
service.interceptors.request.use(
    config => {
        config.headers = config.headers || {}
        if (localStorage.getItem('token')) {
            config.headers.token = localStorage.getItem('token') || ""
        }
        return config
    })

//响应拦截
service.interceptors.response.use(
    response => {
         return response.data
        // const res = response.data
        // if (res.code === 'success' || res.code === 'error') {
        //     return res
        // } else if (res.code === 401 || res.code === 400) {
        //     console.log('返回错误内容', res)
        //     router.push('404')
        //     return res
        // } else if (res.code === 500) {
        //     router.push('500')
        //     return Promise.reject('error')
        // } else if (res.code === 502) {
        //     router.push('502')
        //     return Promise.reject('error')
        // } else {
        //     return Promise.reject('error')
        // }
    },
    error => {
        // 出现网络超时
        router.push('500')
        return Promise.reject(error)
    }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js